<script setup lang="ts">
import { nextTick, onMounted, onUnmounted, reactive } from "vue";

let resizeObserver: ResizeObserver | null = null;

const sizes = reactive({
  width: 0,
  height: 0,
});

function init() {
  const btn = document.querySelector(".reaction-button-wrapper") as HTMLElement;
  if (btn) {
    resizeObserver = new ResizeObserver((entries) => {
      const el = entries[0].target as HTMLElement;
      const w = el.clientWidth;
      const h = el.clientHeight;
      sizes.width = w;
      sizes.height = h;
    });
    resizeObserver.observe(btn);
  } else {
    nextTick(() => {
      init();
    });
  }
}

onMounted(() => {
  init();
});
onUnmounted(() => {
  if (resizeObserver) {
    resizeObserver.disconnect();
  }
});
</script>
<template>
  <div
    class="reaction-button-spacer"
    :style="{
      width: `${sizes.width}px`,
      height: `${sizes.height}px`,
    }"
  ></div>
</template>

<style scoped>
.reaction-button-spacer {
  opacity: 0;
  color: transparent;
  background: transparent;
  height: 44px;
}
</style>
